function monthInterval(month, year, initialDay, finalDay) {
  if (!month && !year) {
    return undefined
  }
  if (month < 1 || month > 12) {
    throw new Error('Month should be in the range 1-12.')
  }

  if (initialDay && (initialDay < 1 || initialDay > 31)) {
    throw new Error('Initial day should be in the range 1-31.')
  }

  if (finalDay && (finalDay < 1 || finalDay > 31)) {
    throw new Error('Final day should be in the range 1-31.')
  }

  const date = new Date()

  const currentYear = year === undefined ? date.getFullYear() : year

  const formattedMonth = String(month).padStart(2, '0')
  const formattedInitialDay = String(initialDay || 1).padStart(2, '0')
  const formattedFinalDay = String(finalDay || 1).padStart(2, '0')

  if (month === 12) {
    return `${currentYear}-${formattedMonth}-${formattedInitialDay},${
      currentYear + 1
    }-01-${formattedFinalDay}`
  }

  const nextMonth = String(month + 1).padStart(2, '0')

  if (!month) {
    return `${currentYear}-01-${formattedInitialDay},${
      currentYear + 1
    }-01-${formattedFinalDay}`
  }
  return `${currentYear}-${formattedMonth}-${formattedInitialDay},${currentYear}-${nextMonth}-${formattedFinalDay}`
}
export default monthInterval
